//permissions.js
import { AbilityBuilder, createMongoAbility } from '@casl/ability';
import {
  Actions,
  AppArea,
  Permission,
  Subjects,
  User,
} from 'src/graphql/generated/graphql';
import { AppAbility } from './ability';

export function createSubject(appArea: AppArea, subject: Subjects) {
  const separator = '_';
  return `${appArea}${separator}${subject}`;
}

// define abilities
export default function defineAbilityFor(user: User | undefined) {
  const { can, build } = new AbilityBuilder<AppAbility>(createMongoAbility);
  const readAction = Actions.Read;

  if (!user) {
    return build();
  }

  if (user.permissions == null || user.permissions?.length === 0) {
    return build();
  }

  const addedAppAreas: { [id: string]: boolean } = {};

  for (const permission of user.permissions as Permission[]) {
    const { appArea, subject, action, condition } = permission;
    const actualSubject = createSubject(appArea, subject);
    can(
      action,
      actualSubject,
      condition ? { id: { $eq: condition } } : undefined,
    );

    if (!addedAppAreas[appArea]) {
      addedAppAreas[appArea] = true;
      can(readAction, appArea);
    }
  }

  return build();
}
